import { callApi } from "Apis";
import { EVENTBOOKINGURL } from "helpers/constant";

export async function eventBookingList(data) {
  try {
    const response = await callApi({ url: EVENTBOOKINGURL.LIST, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}
export async function addEventBookingApi(data) {
  try {
    const response = await callApi({ url: EVENTBOOKINGURL.ADD, body: data, method: "POST" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function updateBookingStatus(data) {
  try {
    const response = await callApi({ url: EVENTBOOKINGURL.UPDATE, body: data, method: "PUT" });
    return response;
  } catch (err) {
    throw err;
  }
}
